<template>
  <div>
    <px-view-header title="Painel de cotações" :breadcrumbs="breadcrumbs">
      <template v-slot:after>
        <px-ajuda-icon :link="linkAjuda"/>
      </template>
    </px-view-header>

    <px-premium-banner/>

    <div class="mt-10">
      <px-painel-cotacoes-header @change="onClickRefresh"/>
      <v-row class="px-2 mt-2" v-if="hasAdvancedFilters">
        <px-painel-cotacoes-filtros-selecionados @change="onClickRefresh"/>
        <v-spacer/>
        <v-btn color="primary" text small @click="clearFilters">
          Limpar filtros
        </v-btn>
      </v-row>
    </div>

    <div v-if="loading">
      <px-circular-loading/>
    </div>

    <div v-if="!loading && (!cotacoes || !cotacoes.total)"
         align="center"
         class="headline mb-5 mt-10">
      Nenhuma oportunidade de frete encontrada
    </div>
    <div v-if="!loading && cotacoes && cotacoes.total">
      <template v-for="cotacao in cotacoes.content">
        <px-painel-cotacoes-item :key="cotacao.id" :cotacao="cotacao"/>
      </template>
      <div class="mt-3 ml-2 caption">
        {{ cotacoes.total }} oportunidades encontradas
      </div>
      <div class="text-center">
        <v-pagination
          v-model="page"
          :length="pagesLimit"
          :total-visible="8"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { CLEAR_FILTERS } from '@/store/painel-cotacao/actions.type';
import paginationMixin from '@/mixins/pagination-mixin';
import { apresentacaoPremium } from '@/api/ajuda-mapper';
import PainelCotacoesHeader from './PainelCotacoesHeader.vue';
import PainelCotacaoService from './painel-cotacoes';
import PainelCotacoesItem from './PainelCotacoesItem.vue';
import PainelCotacoesFiltrosSelecionados from './PainelCotacoesFiltrosSelecionados.vue';

const LIMIT = 10;
const PAGE = 1;

export default {
  mixins: [paginationMixin],
  data() {
    return {
      page: PAGE,
      pagesLimit: 1,
      loading: false,
      cotacoes: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: PAGE,
        limit: LIMIT,
        offset: 0,
        filter: '',
        sort: 'createdIn',
        sortDesc: true,
      },
      optionsList: {
        page: PAGE,
        itemsPerPage: LIMIT,
        sortBy: '',
        sortDesc: false,
        multiSort: false,
      },
      breadcrumbs: [
        { text: 'Negócios' },
        { text: 'Painel de cotações' },
      ],
    };
  },
  computed: {
    linkAjuda() {
      return apresentacaoPremium;
    },
    ...mapGetters('painelCotacao', ['valorMercadoria', 'peso', 'municipiosColeta', 'estadosColeta', 'hasAdvancedFilters', 'query', 'selectedStatusText']),
  },
  methods: {
    ...mapActions('painelCotacao', {
      clearFiltersAction: CLEAR_FILTERS,
    }),
    clearFilters() {
      this.clearFiltersAction();
      this.resetPage();
      this.getCotacoes();
    },
    resetPage() {
      this.page = 1;
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    onClickRefresh() {
      this.getCotacoes();
    },
    onChangeOptions() {
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getCotacoes();
    },
    setPagesLimit() {
      this.pagesLimit = Math.ceil(this.cotacoes.total / LIMIT);
    },
    getCotacoes() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      PainelCotacaoService.getCotacoes({
        limit,
        offset,
        query: this.query,
        meusLocaisColeta: this.selectedStatusText,
      })
        .then(({ data }) => {
          this.cotacoes = data;
          this.setPagesLimit();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    page(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.optionsList.page = newValue;
      this.onChangeOptions();
    },
  },
  created() {
    this.getCotacoes();
  },
  components: {
    pxPainelCotacoesHeader: PainelCotacoesHeader,
    pxPainelCotacoesItem: PainelCotacoesItem,
    pxPainelCotacoesFiltrosSelecionados: PainelCotacoesFiltrosSelecionados,
  },
};
</script>
